<template>
  <div
    class="header-box"
    :style="isRe ? 'position: relative' : 'position: fixed'"
  >
    <div
      class="header_main"
      @mouseover="handleMenuOver"
      @mouseout="handleMenuOut"
      :style="logoShowBlack ? 'background:#fff' : ''"
    >
      <div
        class="header_main_bg"
        :class="{ menu_bg_white: logoShowBlack }"
        :style="{ opacity: !logoShowBlack ? bgShowOp : 1 }"
        @mouseout="handleMouseout"
      ></div>
      <img
        v-if="!logoShowBlack"
        class="logo"
        src="../assets/image/logo_black.png"
        alt=""
      />
      <img
        v-if="logoShowBlack"
        class="logo"
        src="../assets/image/logo_black.png"
        alt=""
      />
      <div class="menu">
        <div
          :id="'menu' + index"
          :class="{ menu_col: logoShowBlack, isActive: active === item.name }"
          class="menu_item"
          v-for="(item, index) in menuList"
          :key="index"
          @mouseover="handleMouseOver(item, index)"
          @click="tabPage(item)"
        >
          {{ item.name }}
          <div class="menu_line" v-if="active === item.name"></div>
        </div>
      </div>
      <div class="header-top" @mouseover="handleMouseOverTop">
        <!-- <div class="child-menu net-web">
            <div class="child-menu-name">
              天信PaaS平台
              <i style="color: white" class="el-icon-arrow-down"></i>
            </div>

            <ul class="child-menu-list">
              <li><a href="/developer.html#/fewCode">低代码开发平台</a></li>
              <li><a href="/developer.html#/passManage">大数据管理平台</a></li>
              <li><a href="/developer.html#/txOt">OT服务平台</a></li>
              <li>
                <a href="http://58.210.154.140:38889/" target="_blank"
                  >容器平台</a
                >
              </li>
            </ul>
          </div> -->

        <div class="child-menu net-link">
          <div class="child-menu-name">
            天信云子站
            <i style="color: #000;" class="el-icon-arrow-down"></i>
          </div>

          <ul class="child-menu-list">
            <li>
              <a href="http://saas.ciicp.com" target="_blank">云应用平台</a>
            </li>
            <li>
              <a href="http://ks.ciicp.com" target="_blank">矿山云平台</a>
            </li>
            <li>
              <a href="https://huozhu.da156.cn/" target="_blank"
                >物流服务平台</a
              >
            </li>
            <li>
              <a href="https://lianmeng.da156.cn/" target="_blank"
                >运力联盟平台</a
              >
            </li>
            <li>
              <a href="https://houtai.da156.cn/" target="_blank"
                >物流管理平台</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="login_content">
        <div v-if="loginState">
          <el-popover
            placement="bottom"
            trigger="hover"
            @show="handleClickUser"
            @hide="handleClickUser"
          >
            <div class="user_pop">
              <div
                class="logOut"
                @mouseover="logoMouseOver(1)"
                @mouseout="logoMouseOut"
                @click="handleGotoAdmin"
              >
                <img
                  v-if="choseLogo === 1"
                  src="../assets/image/home/header-1-active.png"
                  alt=""
                /><img
                  v-else
                  src="../assets/image/home/header-1.png"
                  alt=""
                />企业控制台
              </div>
              <div
                class="logOut"
                @mouseover="logoMouseOver(2)"
                @mouseout="logoMouseOut"
                @click="handleGotoAdmin"
              >
                <img
                  v-if="choseLogo === 2"
                  src="../assets/image/home/wait-active.png"
                  alt=""
                /><img v-else src="../assets/image/home/wait.png" alt="" />待办
                <span style="color: #ff3434">（{{ total }}）</span>
              </div>
              <div
                class="logOut"
                @mouseover="logoMouseOver(3)"
                @mouseout="logoMouseOut"
                @click="handleGotoUser('logOut')"
              >
                <img
                  v-if="choseLogo === 3"
                  src="../assets/image/home/logout-active.png"
                  alt=""
                /><img
                  v-else
                  src="../assets/image/home/logout.png"
                  alt=""
                />退出登录
              </div>
            </div>
            <div
              slot="reference"
              class="username"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <div
                :class="{ 'username-white': logoShowBlack }"
                class="username"
              >
                {{ userInfo.nick_name ? userInfo.nick_name : "noName" }}
                {{ userInfo.companyName ? `（${userInfo.companyName}）` : "" }}
              </div>
              <i
                v-if="showArror"
                :class="{ 'username-white': logoShowBlack }"
                class="el-icon-caret-bottom username"
              ></i>
              <i
                v-if="!showArror"
                :class="{ 'username-white': logoShowBlack }"
                class="el-icon-caret-top username"
              ></i>
            </div>
          </el-popover>
        </div>
      </div>
      <div
        :style="{ left: 0 + 'px' }"
        id="menu_dia"
        v-if="menuOut"
        :class="menuOut ? 'menu_dialog_active' : 'menu_dialog'"
      >
        <div class="left_dia">
          <div class="dia_left_title">
            {{ showMenuTitle }}
          </div>
          <!--          <div class="dia_left_subTitle">-->
          <!--&lt;!&ndash;            {{ titleDetail }}&ndash;&gt;-->
          <!--&lt;!&ndash;            <img style="width: 12px;height: 10px;" src="../assets/image/arrow.svg" alt="">&ndash;&gt;-->
          <!--          </div>-->
        </div>
        <div class="height-hh">
          <div
            :class="
              subMenuList.length > 1
                ? 'menu_dia_main addWidth'
                : 'menu_dia_main'
            "
            id="subMenuList"
          >
            <!-- <p class="dia_line" v-if="subMenuList.length > 1"></p> -->
            <!-- <img src="../assets/image/menu_dia_right.svg" class="dia_right_img" /> -->
            <div
              class="dia_main_item"
              v-for="(item, index) in subMenuList"
              :key="index"
              @click="handleGotoSubDetail(item)"
              @mouseout="MouseoutMain()"
              @mouseover="harderMain(index)"
            >
              <div
                class="title"
                :style="{
                  color: index + 1 == styleIndex ? '#0052D9' : '#16181A',
                }"
                style="word-break: break-all"
              >
                {{ item.name }}
              </div>
              <div class="subTitle">
                <div
                  style="
                    white-space: pre-wrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    line-height: 1.5;
                    color: #797a7a;
                  "
                >
                  {{ item.info ? item.info : item.description }}
                </div>
                <!-- <span v-for="(itemB, indexB) in item.areaList" v-if="indexB<2" :style="{backGround:index+1 == styleIndex?'#F0F3F8':'#F0F3F8',color:index+1 == styleIndex?'#0052D9':'#4E5969'}" :key="indexB+'B'">{{itemB}}</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :style="{ left: showLeft - 10 + 'px' }"
        id="menu_dia"
        v-if="menuOutabout"
        :class="menuOutabout ? 'menu_dialog_active' : 'menu_dialog'"
      >
        <div
          style="
            width: 160px;
            display: flex;
            flex-direction: column;
            background: #fff;
            padding: 10px 0;
            border-radius: 6px;
          "
        >
          <div
            :style="{
              background:
                index + 1 == styleIndex ? 'rgb(0 82 217 / 10%)' : '#fff',
            }"
            style="
              width: 160px;
              height: 42px;
              line-height: 42px;
              text-align: center;
            "
            v-for="(item, index) in subMenuList"
            :key="index + 1"
            @mouseout="MouseoutMain()"
            @mouseover="harderMain(index)"
          >
            <div
              class="title"
              :style="{
                color: index + 1 == styleIndex ? '#0052D9' : '#16181A',
              }"
              @click="handleGotoSub(item.url)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loginState" class="login_btn">
        <div
          :class="{ menu_col: logoShowBlack }"
          class="login"
          @click="handleLogin"
        >
          登录
        </div>
        <div class="singIn" @click="handleSignin">免费注册</div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/config/bus";
export default {
  name: "pubHeader",
  props: {
    msg: String,
  },
  data() {
    return {
      isRe: false,
      showArror: false,
      choseLogo: 0,
      subName: "",
      total: 0,
      userInfo: {},
      styleIndex: 0,
      titleDetail: "",
      jieJueText: "查看全部解决方案",
      aboutText:
        "天瑞信科（河南）数字科技有限公司。从事信息技术集成、软件开发销售、企业信息化、智能化解决方案及工业互联网平台研发运营有关的国家级高新技术企业和软件企业",
      logoShowBlack: false,
      scrollTop: 0,
      bgShowOp: 0,
      loginState: false,
      subMenuList: [],
      showMenuTitle: "",
      menuOut: false,
      menuOutabout: false,
      showLeft: 0,
      active: "",
      keepBlack: true,
      menuList: [
        {
          name: "首页",
          url: "index.html#/",
          children: [],
        },
        {
          name: "产品中心",
          url: "",
          children: [],
        },
        {
          name: "解决方案",
          url: "",
          children: [],
        },
        {
          name: "客户案例",
          url: "",
          children: [],
        },
        {
          name: "供需大厅",
          url: "/supplyHall.html#/supplyHall",
          children: [],
        },
        {
          name: "生态合作",
          url: "/about.html#/cooperation",
          children: [],
        },
        {
          name: "数字化转型",
          url: "/index.html#/digitalTransformate",
          children: [],
        },
        {
          name: "应用市场",
          url: "appStore.html#/market",
          children: [],
        },
        {
          name: "新闻中心",
          url: "index.html#/newsCenter",
          children: [],
        },
        // {
        //   name: '开发平台',
        //   url: '/developer.html#',
        //   children: [],
        // },
        // {
        //   name: '应用市场',
        //   url: '/appStore.html#',
        //   // children: [{
        //   //   name: '应用市场',
        //   //   url: '/appStore.html#/index',
        //   //   content: '',
        //   // },],
        // },
        {
          name: "关于我们",
          url: "/about.html#",
          children: [
            {
              name: "公司简介",
              url: "/about.html#/about",
              content: "以客户为中心、以奋斗创新者为本；自我批评，不留遗憾",
            },
            {
              name: "联系我们",
              url: "/about.html#/ContactUs",
              content: "电话：0375-6033699",
            },
            {
              name: "人才招聘",
              url: "/about.html#/recruit",
              content: "你从来都不是配角，做不伪装的自己，我们了解你的价值",
            },
          ],
        },
      ],
      blackLogoMenu: [
        "newsDetail",
        "recruitDeatil",
        "appDetails",
        "companyApprove",
        "trialManage",
        "productBuy",
        "supplyHall",
        "supplyDetail",
        "newsCenter",
        "productBuyDetail",
        "onlineMsg",
        "about",
        "cooperation",
        "planDetail",
        "developerApprove",
        "developerDetail",
        "market",
        "marketDetails",
        "digitalTransformate",
      ],
      notHeader: ["planDetail", "productDetail", "caseDetail"],
      timer: null,
      subMenuScrollHeight: "",
    };
  },
  watch: {
    scrollTop() {
      if (!this.keepBlack) {
        if (this.scrollTop > 570) {
          this.logoShowBlack = true;
        } else {
          this.logoShowBlack = false;
        }
      } else {
        this.logoShowBlack = true;
      }
    },
    $route(n, o) {
      if (this.blackLogoMenu.includes(this.$route.name)) {
        this.logoShowBlack = true;
        this.keepBlack = true;
      } else {
        this.logoShowBlack = false;
        this.keepBlack = false;
      }
      this.active = n.meta.parentTitle ? n.meta.parentTitle : n.meta.title;
      console.log(this.$route.name);
      if (this.notHeader.includes(this.$route.name)) {
        this.isRe = true;
      } else {
        this.isRe = false;
      }
    },
  },
  beforeDestroy() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    this.getUserState();
    this.getMainMenu();
    Bus.$on("updateFileList", (data, index) => {
      // data是接收的参数
      this.handleMouseOver(data, index);
      console.log(data, index, "------------");
    });
  },
  methods: {
    handleClickUser() {
      this.showArror = !this.showArror;
    },
    async getTotal() {
      let res = await this.API.home.getTotal();
      if (res.code == 200) {
        this.total = res.data;
      }
    },
    async getMainMenu() {
      let res = await this.API.home.getMainMenu();
      if (res.code == 200) {
        this.menuList[1].children = [];
        this.menuList[2].children = [];
        this.menuList[3].children = [];
        res.data.productList.forEach((ele) => {
          this.menuList[1].children.push({
            ...ele,
            hyList: ele.industry ? ele.industry.split(",") : "",
            areaList: ele.area ? ele.area.split(",") : "",
          });
        });
        res.data.schemeList.forEach((ele) => {
          this.menuList[2].children.push({
            ...ele,
            hyList: ele.industry ? ele.industry.split(",") : "",
            areaList: ele.area ? ele.area.split(",") : "",
          });
        });
        res.data.caseList.forEach((ele) => {
          this.menuList[3].children.push({
            ...ele,
            hyList: ele.industry ? ele.industry.split(",") : "",
            areaList: ele.area ? ele.area.split(",") : "",
          });
        });
      }
    },
    async getUserState() {
      if (!localStorage.getItem("userInfo")) {
        this.loginState = false;
        return;
      }
      let params = {
        id: localStorage.getItem("userInfo")
          ? JSON.parse(localStorage.getItem("userInfo")).user_id
          : "",
      };
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const res = await this.API.accountSettings.accountdetail(params);
      if (res.code == 200 && res.data) {
        this.userInfo.companyName = res.data.companyName;
        this.userInfo.nick_name = res.data.realName;
        if (this.userInfo && this.userInfo.user_id) {
          this.loginState = true;
          this.getTotal();
        } else {
          this.loginState = false;
        }
      }
    },
    handleGotoAdmin() {
      let type = localStorage.getItem("type");
      if (type !== "1") {
        window.location.href = "/admin.html#/systemSet/companyDetail";
      } else {
        this.getMenu();
      }
    },
    async getMenu(conditions) {
      let prarm = { code: "", name: "" };
      const result = await this.API.user.menuslist(prarm);
      if (result.code == "200" && result.success == true) {
        if (result.data[0].children && result.data[0].children.length > 0) {
          window.location.href =
            "/admin.html#" + result.data[0].children[0].path;
        } else {
          window.location.href = "/admin.html#" + result.data[0].path;
        }
      } else {
        this.$message({
          type: "warning",
          message: "当前用户无登录权限",
        });
      }
    },
    handleLogin() {
      window.location.href = "/login.html#/";
    },
    handleSignin() {
      window.location.href = "/register.html#/";
    },
    handleGotoSubDetail(obj) {
      this.menuOut = false;
      this.menuOutabout = false;
      this.subMenuList = [];
      this.showMenuTitle = "";
      switch (this.subName) {
        case "解决方案":
          window.location.href = `/product.html#/planDetail?id=${obj.id}`;
          break;
        case "产品中心":
          window.location.href = `/product.html#/detail?id=${obj.id}`;
          break;
        case "客户案例":
          window.location.href = `/product.html#/caseDetail?id=${obj.id}`;
          break;
      }
    },
    handleGotoSub(obj) {
      if (obj.indexOf("html#") != -1) {
        window.location.href = obj;
      } else {
        this.$router.push(obj);
      }
    },

    tabPage(item) {
      if (item.url.indexOf("html#") != -1) {
        window.location.href = item.url;
      } else if (item.url == "") {
      } else {
        this.$router.push(item.url);
      }
    },
    handleScroll(e) {
      this.scrollTop = document.documentElement.scrollTop;
    },
    logoMouseOver(val) {
      console.log("over");
      this.choseLogo = val;
    },
    logoMouseOut() {
      this.choseLogo = 0;
      console.log("out");
    },
    handleMenuOver() {
      if (!this.logoShowBlack && this.scrollTop > 570 && !this.keepBlack) {
        this.bgShowOp = 0.3;
      }
    },
    handleMenuOut() {
      if (this.logoShowBlack && this.scrollTop <= 570 && !this.keepBlack) {
        this.bgShowOp = 0;
        this.logoShowBlack = false;
      }
    },
    harderMain(index) {
      this.styleIndex = index + 1;
    },
    MouseoutMain() {
      this.styleIndex = 0;
    },
    handleGotoUser(type) {
      localStorage.clear();
      this.$message.success("登出成功！");
      this.loginState = false;
      if (
        this.$route.path == "/developerApprove" ||
        this.$route.path == "/developerDetail"
      ) {
        this.$router.push({
          path: "/cooperation",
        });
      }
    },
    handleMouseOverTop() {
      this.handleMouseout();
      this.MouseoutMain();
    },
    handleMouseout() {
      // if(this.active){
      //移出

      // this.active = ''
      this.menuOut = false;
      this.menuOutabout = false;
      this.subMenuList = [];
      this.showMenuTitle = "";
      // }

      // this.logoShowBlack = false
    },
    handleMouseOver(item, index) {
      console.log(item, "========handleMouseOver=====", index);
      //进入
      if (item.name == "解决方案") {
        item.name == "解决方案"
          ? (this.titleDetail = this.jieJueText)
          : (this.titleDetail = this.aboutText);
        this.subName = "解决方案";
        this.subMenuList = item.children;
        if (this.subMenuList.length > 0) {
          this.menuOut = true;
        } else {
          this.menuOut = false;
        }
        this.showMenuTitle = item.name;
      } else if (item.name == "产品中心") {
        this.subName = "产品中心";
        this.titleDetail = "查看全部产品";
        this.subMenuList = item.children;
        if (this.subMenuList.length > 0) {
          this.menuOut = true;
        } else {
          this.menuOut = false;
        }
        this.showMenuTitle = item.name;
      } else if (item.name == "客户案例") {
        this.subName = "客户案例";
        this.titleDetail = "查看全部客户案例";
        this.subMenuList = item.children;
        this.showMenuTitle = item.name;
        if (this.subMenuList.length > 0) {
          this.menuOut = true;
        } else {
          this.menuOut = false;
        }
      } else if (item.name == "关于我们") {
        this.menuOutabout = true;
        this.subMenuList = item.children;
      } else {
        this.menuOut = false;
        this.menuOutabout = false;
      }
      if (document.body.clientWidth > 1366) {
        this.showLeft = document
          .getElementById("menu" + index)
          .getBoundingClientRect().left;
      } else {
        if (
          item.name == "解决方案" ||
          item.name == "产品中心" ||
          item.name == "客户案例"
        ) {
          this.showLeft =
            document.getElementById("menu" + index).getBoundingClientRect()
              .left - 200;
        } else {
          this.showLeft = document
            .getElementById("menu" + index)
            .getBoundingClientRect().left;
        }
      }
      // this.active = item.name
      let arr = ["解决方案", "产品中心", "客户案例"];
      if (arr.some((itm) => itm == item.name)) {
        this.timer = setTimeout(() => {
          let scrollHeight =
            document.querySelector("#subMenuList").scrollHeight;
          if (
            this.subMenuScrollHeight &&
            this.subMenuScrollHeight != scrollHeight
          ) {
            this.subMenuScrollHeight = scrollHeight - 20;
          } else {
            this.subMenuScrollHeight = scrollHeight;
          }
          this.timer = null;
        }, 0);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.login_btn {
  display: flex;
  position: absolute;
  right: 0;
  .login {
    font-family: "Microsoft YaHei";
    font-weight: 400;
    font-size: 14px;
    color: #000;
    width: 60px;
    text-align: center;
    line-height: 64px;
    cursor: pointer;
  }

  .singIn {
    width: 120px;
    height: 64px;
    background: #165dff;
    line-height: 64px;
    text-align: center;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: #fff;
    cursor: pointer;
  }
}

.header-box {
  width: 100%;
  height: 94px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  .header-top {
    // width: 100%;
    // height: 30px;
    // background: #191c22;
    position: relative;

    .child-menu {
      // position: absolute;
      // top: 0;

      .child-menu-name {
        // color: #fff;
        width: 160px;
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 14px;
        height: 30px;
      }

      &.net-web {
        right: 300px;
        z-index: 999;

        .child-menu-name:before {
          content: url("../assets/image/netweb.svg");
          width: 16px;
          height: 16px;
          display: inline-block;
          margin-right: 5px;
        }

        &:hover .child-menu-list {
          display: block;
        }
      }

      &.net-link {
        right: 120px;
        z-index: 999;

        .child-menu-name:before {
          width: 16px;
          height: 16px;
          content: url("../assets/image/link.svg");
          display: inline-block;
          margin-right: 5px;
        }

        &:hover .child-menu-list {
          display: block;
        }
      }

      .child-menu-list {
        position: absolute;
        display: none;
        background: #fff;
        width: 160px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;

        li {
          height: 50px;
          line-height: 50px;
          text-align: center;

          a {
            color: #16181a;
          }
        }

        li:hover {
          background: #0052d9;

          a {
            color: #fff;
          }
        }
      }
    }
  }
}

.header_main {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  background: #fff;
  color: #000;
}

.header_main_bg {
  width: 100%;
  height: 64px;
  z-index: -1;
  background: #fff !important;
  filter: blur(2px);
  opacity: 0;
  position: absolute;
  top: 30px;
  left: 0;
}

.logo {
  // width: 190px;
  margin-left: 3%;
  height: 100%;
}

.menu {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-left: 38px;

  .menu_item {
    width: 110px;
    text-align: center;
    line-height: 64px;
    height: 64px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000;
    position: relative;
    cursor: pointer;
  }

  .menu_line {
    position: absolute;
    bottom: 0;
    left: 0;
    margin-left: 5px;
    width: 100px;
    height: 4px;
    background: #1E4DA5;
  }

  .isActive {
    font-weight: bold;
    color: #000;
    /*background: rgba(255, 255, 255, 0.4);*/
    border-radius: 2px;
  }
}

@keyframes slide-down {
  0% {
    transform: scale(1, 0);
  }

  100% {
    transform: scale(1, 1);
  }
}

@-webkit-keyframes slide-down {
  0% {
    -webkit-transform: scale(1, 0);
  }

  100% {
    -webkit-transform: scale(1, 1);
  }
}

.menu_dialog {
  position: fixed;
  top: 64px;
  width: 900px;
  height: 0;
  padding-top: 0;
  background: transparent;
  border-radius: 0 6px 6px 0;
  overflow: auto;
  transition: height 0.06s ease-out, padding-top 0.06s ease-out;
}

.menu_dialog_active {
  width: 100%;
  max-height: 600px;
  position: fixed;
  top: 60px;
  /* max-width: 740px; */
  padding-top: 4px;
  background: transparent;
  // border-radius: 0 12px 12px 0;
  transition: height 0.1s ease-in;
  transform-origin: 50% 0;
  animation: slide-down 0.3s ease-in;
  -webkit-animation: slide-down 0.3s ease-in;
}

.addWidth {
  width: 700px;
}
.height-hh {
  // height: 463px;
  background: white;
  overflow: auto;
  flex: 1;
}
.menu_dia_main {
  width: 100%;
  min-width: 154px;
  padding: 32px 30px;
  // border-radius: 0 6px 6px 0;
  position: relative;
  display: flex;
  gap: 20px;
  // flex-direction: column;
  flex-wrap: wrap;
  // justify-content: space-between;
  .dia_line {
    // position: absolute;
    // height: 100%;
    // border: 1px solid #E8E8E8;
    // top:20px;
    // right: 51%;
  }

  .dia_right_img {
    position: absolute;
    right: 18px;
    width: 145px;
    height: 139px;
    bottom: 13px;
  }

  .dia_main_item {
    // width: 290px;
    width: 24%;
    /* max-width: 45%; */
    margin-bottom: 24px;
    flex-shrink: 0;
    .title {
      font-family: "PingFang SC Heavy";
      font-weight: 900;
      font-size: 14px;
      text-align: left;
      color: #16181a;
      cursor: pointer;
    }

    .subTitle {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 20px;
      flex-wrap: wrap;
      cursor: pointer;
      span {
        min-width: 60px;
        height: 22px;
        border-radius: 4px;
        background: #f0f3f8;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        font-size: 10px;
        text-align: left;
        color: #4e5969;
        line-height: 22px;
        text-align: center;
        margin-right: 8px;
        margin-bottom: 8px;
      }
    }
  }
}

.menu_dialog_active::-webkit-scrollbar {
  width: 0 !important;
}

.menu_dialog::-webkit-scrollbar {
  width: 0 !important;
}

#menu_dia {
  display: flex;
  // border-radius: 0 12px 6px 6px;
  overflow: hidden;
}

.left_dia {
  background: url("../assets/image/afirser.png");
  background-size: cover;
  width: 222px;
  height: 600px;
  margin-right: -1px;
  // border-radius: 6px 0 0 6px;
  padding: 32px 30px;
  /*border-right: 1px dashed #ccc;*/
  .dia_left_title {
    font-family: "Microsoft YaHei Bold";
    font-weight: 700;
    font-size: 18px;
    text-align: left;
    color: #1d2129;
  }

  .dia_left_subTitle {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #495770;
  }
}

.login_content {
  display: flex;
  // width: 100%;
  // margin-right: 80px;
  justify-content: flex-end;

  .login_btn {
    width: 69px;
    height: 36px;
    background: #0052d9;
    border: 1px solid #0066ff;
    box-shadow: 0px 0px 6px rgba(6, 70, 154, 0.38);
    opacity: 1;
    border-radius: 90px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .other_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 0px;
    color: #495770;
    opacity: 1;
    width: 69px;
    height: 36px;
    background: #ffffff;
    border: 1px solid #ebebeb;
    box-shadow: 0px 0px 6px rgba(6, 70, 154, 0.38);
    border-radius: 90px;
    margin-left: 8px;
  }
}

.user_info {
  width: 36px;
  height: 36px;
}

.user_pop {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 999;
  position: relative;
  .name {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #495770;
    opacity: 1;
    line-height: 42px;
    height: 42px;
  }

  .logOut {
    height: 42px;
    width: calc(100% + 24px);
    line-height: 42px;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #16181a;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 26px;

    img {
      width: 14px;
      margin-right: 4px;
    }
  }

  .logOut:hover {
    color: #0052d9;
    background: rgba(0, 82, 217, 0.1);
  }
}

.hh_flex {
  display: flex;
}

.menu_col {
  color: #16181a !important;
}

.menu_bg_white {
  opacity: 1;
}

.login-text {
  font-size: 16px;
  color: white;
  position: absolute;
  right: 24px;
  top: 8px;
  cursor: pointer;
}

.username {
  color: #000;
  font-size: 14px;
  font-face: Microsoft YaHei;
  font-weight: 700;
  letter-spacing: 0;
}

.username-white {
  color: rgba(29, 33, 41, 1);
  font-size: 14px;
  font-face: Microsoft YaHei;
  font-weight: 700;
  letter-spacing: 0;
}
</style>
